// Panneau admin en partie (choix de Léni, 5 novembre 2026) : niveau max, stats au max, invincible, classe au choix.
// Affiché seulement quand le serveur a reconnu un compte admin à l'entrée ; chaque bouton est revérifié par le serveur.
// Textes en français seulement : seul l'admin le voit.
import { useState } from 'react';
import { CLASSES } from '../../../shared/catalog/classes';
import type { GameClient } from '../game/GameClient';
import type { HudState } from '../game/store';
import { className } from '../i18n/catalog';
import { HudPanel } from './HudPanel';

export function AdminPanel({ state, client }: { state: HudState; client: GameClient }) {
  const [open, setOpen] = useState(false);
  const [cls, setCls] = useState(CLASSES[0].id);
  if (!state.admin) return null;
  const god = state.admin.god;
  const alive = !!state.me;
  return (
    <HudPanel open={open} onToggle={() => setOpen((o) => !o)} title="Admin" summary={god ? 'invincible' : undefined} className="admin-panel" testId="admin-panel">
      <div className="admin-actions">
        <button type="button" className="btn btn-small" disabled={!alive} onClick={() => client.admin('level')} data-testid="admin-level">
          Niveau max
        </button>
        <button type="button" className="btn btn-small" disabled={!alive} onClick={() => client.admin('stats')} data-testid="admin-stats">
          Stats au max
        </button>
        <button type="button" className={`btn btn-small ${god ? 'btn-primary' : ''}`} aria-pressed={god} onClick={() => client.admin('god', { on: !god })} data-testid="admin-god">
          {god ? 'Invincible : oui' : 'Invincible : non'}
        </button>
        <label className="admin-class">
          <span>Classe</span>
          <select value={cls} onChange={(e) => setCls(e.target.value)} data-testid="admin-class-select">
            {CLASSES.map((c) => (
              <option key={c.id} value={c.id}>
                {className(c)} (niv. {c.level})
              </option>
            ))}
          </select>
        </label>
        <button type="button" className="btn btn-small" disabled={!alive} onClick={() => client.admin('class', { cls })} data-testid="admin-class">
          Prendre cette classe
        </button>
      </div>
    </HudPanel>
  );
}
